import { render } from "./ListAndDetails.vue?vue&type=template&id=483154bf"
import script from "./ListAndDetails.vue?vue&type=script&lang=js"
export * from "./ListAndDetails.vue?vue&type=script&lang=js"

import "./ListAndDetails.vue?vue&type=style&index=0&id=483154bf&lang=scss"

import exportComponent from "/Users/dt/Sites/vues/foggyrealm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__